<!--
  This is a corrected DatePicker component as iView DatePicker causes undesirable behavior.
-->
<!-- This component sets date as a string without zone and time, -->
<!--
  while DatePicker sends a timestamp with a zone, which causes dates to be recalculated on Postgres
-->

<template>
  <DatePicker :value="value" @on-change="updated" />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
  },
  methods: {
    updated(value) {
      this.$emit("input", value.toString());
      this.$emit("on-change", value.toString());
    },
  },
};
</script>

<style lang="css"></style>
